export const IMAGE_FORMATS = {
  jpeg: {
    extensions: ['jpg', 'jpeg'],
    mimeTypes: ['image/jpeg', 'image/jpg', 'image/pjpeg']
  },
  png: {
    extensions: ['png'],
    mimeTypes: ['image/png']
  },
  gif: {
    extensions: ['gif'],
    mimeTypes: ['image/gif']
  },
  webp: {
    extensions: ['webp'],
    mimeTypes: ['image/webp']
  },
  bmp: {
    extensions: ['bmp'],
    mimeTypes: ['image/bmp', 'image/x-ms-bmp']
  },
  svg: {
    extensions: ['svg'],
    mimeTypes: ['image/svg+xml']
  },
  tiff: {
    extensions: ['tif', 'tiff'],
    mimeTypes: ['image/tiff']
  },
  avif: {
    extensions: ['avif'],
    mimeTypes: ['image/avif']
  },
  heic: {
    extensions: ['heic'],
    mimeTypes: ['image/heic', 'image/heic-sequence']
  },
  heif: {
    extensions: ['heif'],
    mimeTypes: ['image/heif', 'image/heif-sequence']
  }
};

export const DEFAULT_ENABLED_IMAGE_FORMATS = ['jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'tiff', 'avif'];